webpackJsonp([114276838955818,60335399758886],{

/***/ 102:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Badley"}},"bg":{"sizes":{"base64":"data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAUABQDASIAAhEBAxEB/8QAGAABAAMBAAAAAAAAAAAAAAAAAAIDBAH/xAAWAQEBAQAAAAAAAAAAAAAAAAABAgP/2gAMAwEAAhADEAAAAcsqrg4yqmiROkQn/8QAHBAAAQQDAQAAAAAAAAAAAAAAAQACAxMQERIh/9oACAEBAAEFAqlV7QVHIS6UNDzIdro4/8QAGBEBAAMBAAAAAAAAAAAAAAAAAQAQExH/2gAIAQMBAT8BxE7My//EABoRAAAHAAAAAAAAAAAAAAAAAAABEBESEyH/2gAIAQIBAT8Bs1hI1//EABsQAAIBBQAAAAAAAAAAAAAAAAABIQIQESBR/9oACAEBAAY/AhLtpZS8xr//xAAbEAEAAwEAAwAAAAAAAAAAAAABABExIRBBUf/aAAgBAQABPyEX0jSwXiNuQMPUGt/bksKyCjyKa+P/2gAMAwEAAgADAAAAEMvPAP/EABgRAQEAAwAAAAAAAAAAAAAAAAEAEBFh/9oACAEDAQE/EDQG6sLj/8QAFhEBAQEAAAAAAAAAAAAAAAAAARAR/9oACAECAQE/EFGkEJ//xAAcEAEAAwACAwAAAAAAAAAAAAABABEhMUFRgZH/2gAIAQEAAT8QvAhfGwVd6l81A0jyojahKbA7AhyYhQd0+y9KmdueorP/2Q==","aspectRatio":1,"src":"/static/bg-5419285cb2cb8c0d0e3ea336c78dc56d-78827.jpg","srcSet":"/static/bg-5419285cb2cb8c0d0e3ea336c78dc56d-8ebea.jpg 360w,\n/static/bg-5419285cb2cb8c0d0e3ea336c78dc56d-c5791.jpg 720w,\n/static/bg-5419285cb2cb8c0d0e3ea336c78dc56d-78827.jpg 1440w,\n/static/bg-5419285cb2cb8c0d0e3ea336c78dc56d-f9427.jpg 2160w,\n/static/bg-5419285cb2cb8c0d0e3ea336c78dc56d-a6019.jpg 2880w","sizes":"(max-width: 1440px) 100vw, 1440px"}}},"layoutContext":{}}

/***/ }),

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(202);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(102);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(214), __esModule: true };

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(216), __esModule: true };

/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(206);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ }),

/***/ 127:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(239);
	module.exports = __webpack_require__(12).Object.assign;


/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(241);
	module.exports = __webpack_require__(12).Object.keys;


/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(21);
	var getKeys = __webpack_require__(44);
	var gOPS = __webpack_require__(80);
	var pIE = __webpack_require__(59);
	var toObject = __webpack_require__(61);
	var IObject = __webpack_require__(133);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(28)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(27);
	var core = __webpack_require__(12);
	var fails = __webpack_require__(28);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(27);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(229) });


/***/ }),

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(61);
	var $keys = __webpack_require__(44);
	
	__webpack_require__(233)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),

/***/ 301:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(42);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(57);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(56);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _objectWithoutProperties2 = __webpack_require__(127);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(126);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Handle legacy names for image queries.
	var convertProps = function convertProps(props) {
	  var convertedProps = (0, _extends3.default)({}, props);
	  if (convertedProps.responsiveResolution) {
	    convertedProps.resolutions = convertedProps.responsiveResolution;
	    delete convertedProps.responsiveResolution;
	  }
	  if (convertedProps.responsiveSizes) {
	    convertedProps.sizes = convertedProps.responsiveSizes;
	    delete convertedProps.responsiveSizes;
	  }
	
	  return convertedProps;
	};
	
	// Cache if we've seen an image before so we don't both with
	// lazy-loading & fading in on subsequent mounts.
	var imageCache = {};
	var inImageCache = function inImageCache(props) {
	  var convertedProps = convertProps(props);
	  // Find src
	  var src = convertedProps.sizes ? convertedProps.sizes.src : convertedProps.resolutions.src;
	
	  if (imageCache[src]) {
	    return true;
	  } else {
	    imageCache[src] = true;
	    return false;
	  }
	};
	
	var io = void 0;
	var listeners = [];
	
	function getIO() {
	  if (typeof io === "undefined" && typeof window !== "undefined" && window.IntersectionObserver) {
	    io = new window.IntersectionObserver(function (entries) {
	      entries.forEach(function (entry) {
	        listeners.forEach(function (l) {
	          if (l[0] === entry.target) {
	            // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	            if (entry.isIntersecting || entry.intersectionRatio > 0) {
	              io.unobserve(l[0]);
	              l[1]();
	            }
	          }
	        });
	      });
	    }, { rootMargin: "200px" });
	  }
	
	  return io;
	}
	
	var listenToIntersections = function listenToIntersections(el, cb) {
	  getIO().observe(el);
	  listeners.push([el, cb]);
	};
	
	var isWebpSupportedCache = null;
	var isWebpSupported = function isWebpSupported() {
	  if (isWebpSupportedCache !== null) {
	    return isWebpSupportedCache;
	  }
	
	  var elem = typeof window !== "undefined" ? window.document.createElement("canvas") : {};
	  if (elem.getContext && elem.getContext("2d")) {
	    isWebpSupportedCache = elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
	  } else {
	    isWebpSupportedCache = false;
	  }
	
	  return isWebpSupportedCache;
	};
	
	var noscriptImg = function noscriptImg(props) {
	  // Check if prop exists before adding each attribute to the string output below to prevent
	  // HTML validation issues caused by empty values like width="" and height=""
	  var src = props.src ? "src=\"" + props.src + "\" " : "src=\"\" "; // required attribute
	  var srcSet = props.srcSet ? "srcset=\"" + props.srcSet + "\" " : "";
	  var sizes = props.sizes ? "sizes=\"" + props.sizes + "\" " : "";
	  var title = props.title ? "title=\"" + props.title + "\" " : "";
	  var alt = props.alt ? "alt=\"" + props.alt + "\" " : "alt=\"\" "; // required attribute
	  var width = props.width ? "width=\"" + props.width + "\" " : "";
	  var height = props.height ? "height=\"" + props.height + "\" " : "";
	  var opacity = props.opacity ? props.opacity : "1";
	  var transitionDelay = props.transitionDelay ? props.transitionDelay : "0.5s";
	
	  return "<img " + width + height + src + srcSet + alt + title + sizes + "style=\"position:absolute;top:0;left:0;transition:opacity 0.5s;transition-delay:" + transitionDelay + ";opacity:" + opacity + ";width:100%;height:100%;object-fit:cover;object-position:center\"/>";
	};
	
	var Img = function Img(props) {
	  var style = props.style,
	      onLoad = props.onLoad,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ["style", "onLoad"]);
	
	  return _react2.default.createElement("img", (0, _extends3.default)({}, otherProps, {
	    onLoad: onLoad,
	    style: (0, _extends3.default)({
	      position: "absolute",
	      top: 0,
	      left: 0,
	      transition: "opacity 0.5s",
	      width: "100%",
	      height: "100%",
	      objectFit: "cover",
	      objectPosition: "center"
	    }, style)
	  }));
	};
	
	Img.propTypes = {
	  style: _propTypes2.default.object,
	  onLoad: _propTypes2.default.func
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image(props) {
	    (0, _classCallCheck3.default)(this, Image);
	
	    // If this browser doesn't support the IntersectionObserver API
	    // we default to start downloading the image right away.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    var isVisible = true;
	    var imgLoaded = true;
	    var IOSupported = false;
	
	    // If this image has already been loaded before then we can assume it's
	    // already in the browser cache so it's cheap to just show directly.
	    var seenBefore = inImageCache(props);
	
	    if (!seenBefore && typeof window !== "undefined" && window.IntersectionObserver) {
	      isVisible = false;
	      imgLoaded = false;
	      IOSupported = true;
	    }
	
	    // Always don't render image while server rendering
	    if (typeof window === "undefined") {
	      isVisible = false;
	      imgLoaded = false;
	    }
	
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: imgLoaded,
	      IOSupported: IOSupported
	    };
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  Image.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.state.IOSupported && ref) {
	      listenToIntersections(ref, function () {
	        _this2.setState({ isVisible: true, imgLoaded: false });
	      });
	    }
	  };
	
	  Image.prototype.render = function render() {
	    var _this3 = this;
	
	    var _convertProps = convertProps(this.props),
	        title = _convertProps.title,
	        alt = _convertProps.alt,
	        className = _convertProps.className,
	        outerWrapperClassName = _convertProps.outerWrapperClassName,
	        _convertProps$style = _convertProps.style,
	        style = _convertProps$style === undefined ? {} : _convertProps$style,
	        _convertProps$imgStyl = _convertProps.imgStyle,
	        imgStyle = _convertProps$imgStyl === undefined ? {} : _convertProps$imgStyl,
	        _convertProps$placeho = _convertProps.placeholderStyle,
	        placeholderStyle = _convertProps$placeho === undefined ? {} : _convertProps$placeho,
	        sizes = _convertProps.sizes,
	        resolutions = _convertProps.resolutions,
	        backgroundColor = _convertProps.backgroundColor,
	        Tag = _convertProps.Tag;
	
	    var bgColor = void 0;
	    if (typeof backgroundColor === "boolean") {
	      bgColor = "lightgray";
	    } else {
	      bgColor = backgroundColor;
	    }
	
	    var imagePlaceholderStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded ? 0 : 1,
	      transitionDelay: "0.25s"
	    }, imgStyle, placeholderStyle);
	
	    var imageStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0
	    }, imgStyle);
	
	    if (sizes) {
	      var image = sizes;
	
	      // Use webp by default if browser supports it
	      if (image.srcWebp && image.srcSetWebp && isWebpSupported()) {
	        image.src = image.srcWebp;
	        image.srcSet = image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: (0, _extends3.default)({
	              position: "relative",
	              overflow: "hidden"
	            }, style),
	            ref: this.handleRef
	          },
	          _react2.default.createElement(Tag, {
	            style: {
	              width: "100%",
	              paddingBottom: 100 / image.aspectRatio + "%"
	            }
	          }),
	          image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.base64,
	            style: imagePlaceholderStyle
	          }),
	          image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              position: "absolute",
	              top: 0,
	              bottom: 0,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.35s",
	              right: 0,
	              left: 0
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            srcSet: image.srcSet,
	            src: image.src,
	            sizes: image.sizes,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.state.IOSupported && _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({ alt: alt, title: title }, image))
	            }
	          })
	        )
	      );
	    }
	
	    if (resolutions) {
	      var _image = resolutions;
	      var divStyle = (0, _extends3.default)({
	        position: "relative",
	        overflow: "hidden",
	        display: "inline-block",
	        width: _image.width,
	        height: _image.height
	      }, style);
	
	      if (style.display === "inherit") {
	        delete divStyle.display;
	      }
	
	      // Use webp by default if browser supports it
	      if (_image.srcWebp && _image.srcSetWebp && isWebpSupported()) {
	        _image.src = _image.srcWebp;
	        _image.srcSet = _image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: divStyle,
	            ref: this.handleRef
	          },
	          _image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.base64,
	            style: imagePlaceholderStyle
	          }),
	          _image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              width: _image.width,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.25s",
	              height: _image.height
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            width: _image.width,
	            height: _image.height,
	            srcSet: _image.srcSet,
	            src: _image.src,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({
	                alt: alt,
	                title: title,
	                width: _image.width,
	                height: _image.height
	              }, _image))
	            }
	          })
	        )
	      );
	    }
	
	    return null;
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.defaultProps = {
	  fadeIn: true,
	  alt: "",
	  Tag: "div"
	};
	
	Image.propTypes = {
	  responsiveResolution: _propTypes2.default.object,
	  responsiveSizes: _propTypes2.default.object,
	  resolutions: _propTypes2.default.object,
	  sizes: _propTypes2.default.object,
	  fadeIn: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  alt: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]), // Support Glamor's css prop.
	  outerWrapperClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  style: _propTypes2.default.object,
	  imgStyle: _propTypes2.default.object,
	  placeholderStyle: _propTypes2.default.object,
	  position: _propTypes2.default.string,
	  backgroundColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  onLoad: _propTypes2.default.func,
	  Tag: _propTypes2.default.string
	};
	
	exports.default = Image;

/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.navigateTo = exports.replace = exports.push = undefined;
	
	var _extends2 = __webpack_require__(126);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(208);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _objectWithoutProperties2 = __webpack_require__(127);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(42);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(57);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(56);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.withPrefix = withPrefix;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(74);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _history = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*global __PREFIX_PATHS__, __PATH_PREFIX__ */
	var pathPrefix = "/";
	if (true) {
	  pathPrefix = ("");
	}
	
	function withPrefix(path) {
	  return normalizePath(pathPrefix + path);
	}
	
	function normalizePath(path) {
	  return path.replace(/^\/\//g, "/");
	}
	
	function createLocation(path, history) {
	  var location = (0, _history.createLocation)(path, null, null, history.location);
	  location.pathname = withPrefix(location.pathname);
	  return location;
	}
	
	var NavLinkPropTypes = {
	  activeClassName: _propTypes2.default.string,
	  activeStyle: _propTypes2.default.object,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  isActive: _propTypes2.default.func,
	  location: _propTypes2.default.object
	
	  // Set up IntersectionObserver
	};var handleIntersection = function handleIntersection(el, cb) {
	  var io = new window.IntersectionObserver(function (entries) {
	    entries.forEach(function (entry) {
	      if (el === entry.target) {
	        // Check if element is within viewport, remove listener, destroy observer, and run link callback.
	        // MSEdge doesn't currently support isIntersecting, so also test for  an intersectionRatio > 0
	        if (entry.isIntersecting || entry.intersectionRatio > 0) {
	          io.unobserve(el);
	          io.disconnect();
	          cb();
	        }
	      }
	    });
	  });
	  // Add element to the observer
	  io.observe(el);
	};
	
	/* eslint-disable react/no-deprecated */
	
	var GatsbyLink = function (_React$Component) {
	  (0, _inherits3.default)(GatsbyLink, _React$Component);
	
	  function GatsbyLink(props, context) {
	    (0, _classCallCheck3.default)(this, GatsbyLink);
	
	    // Default to no support for IntersectionObserver
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this));
	
	    var IOSupported = false;
	    if (typeof window !== "undefined" && window.IntersectionObserver) {
	      IOSupported = true;
	    }
	
	    var history = context.router.history;
	
	    var to = createLocation(props.to, history);
	
	    _this.state = {
	      path: (0, _history.createPath)(to),
	      to: to,
	      IOSupported: IOSupported
	    };
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  GatsbyLink.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.to !== nextProps.to) {
	      var to = createLocation(nextProps.to, history);
	      this.setState({
	        path: (0, _history.createPath)(to),
	        to: to
	      });
	      // Preserve non IO functionality if no support
	      if (!this.state.IOSupported) {
	        ___loader.enqueue(this.state.to.pathname);
	      }
	    }
	  };
	
	  GatsbyLink.prototype.componentDidMount = function componentDidMount() {
	    // Preserve non IO functionality if no support
	    if (!this.state.IOSupported) {
	      ___loader.enqueue(this.state.to.pathname);
	    }
	  };
	
	  GatsbyLink.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    this.props.innerRef && this.props.innerRef(ref);
	
	    if (this.state.IOSupported && ref) {
	      // If IO supported and element reference found, setup Observer functionality
	      handleIntersection(ref, function () {
	        ___loader.enqueue(_this2.state.to.pathname);
	      });
	    }
	  };
	
	  GatsbyLink.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        _onClick = _props.onClick,
	        rest = (0, _objectWithoutProperties3.default)(_props, ["onClick"]);
	
	    var El = void 0;
	    if ((0, _keys2.default)(NavLinkPropTypes).some(function (propName) {
	      return _this3.props[propName];
	    })) {
	      El = _reactRouterDom.NavLink;
	    } else {
	      El = _reactRouterDom.Link;
	    }
	
	    return _react2.default.createElement(El, (0, _extends3.default)({
	      onClick: function onClick(e) {
	        // eslint-disable-line
	        _onClick && _onClick(e);
	
	        if (e.button === 0 && // ignore right clicks
	        !_this3.props.target && // let browser handle "target=_blank"
	        !e.defaultPrevented && // onClick prevented default
	        !e.metaKey && // ignore clicks with modifier keys...
	        !e.altKey && !e.ctrlKey && !e.shiftKey) {
	          // Is this link pointing to a hash on the same page? If so,
	          // just scroll there.
	          var pathname = _this3.state.path;
	          if (pathname.split("#").length > 1) {
	            pathname = pathname.split("#").slice(0, -1).join("");
	          }
	          if (pathname === window.location.pathname) {
	            var hashFragment = _this3.state.path.split("#").slice(1).join("#");
	            var element = document.getElementById(hashFragment);
	            if (element !== null) {
	              element.scrollIntoView();
	              return true;
	            } else {
	              // This is just a normal link to the current page so let's emulate default
	              // browser behavior by scrolling now to the top of the page.
	              window.scrollTo(0, 0);
	              return true;
	            }
	          }
	
	          // In production, make sure the necessary scripts are
	          // loaded before continuing.
	          if (true) {
	            e.preventDefault();
	            window.___push(_this3.state.to);
	          }
	        }
	
	        return true;
	      }
	    }, rest, {
	      to: this.state.to,
	      innerRef: this.handleRef
	    }));
	  };
	
	  return GatsbyLink;
	}(_react2.default.Component);
	/* eslint-enable */
	
	GatsbyLink.propTypes = (0, _extends3.default)({}, NavLinkPropTypes, {
	  innerRef: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired
	});
	
	GatsbyLink.contextTypes = {
	  router: _propTypes2.default.object
	};
	
	exports.default = GatsbyLink;
	var push = exports.push = function push(to) {
	  window.___push(to);
	};
	
	var replace = exports.replace = function replace(to) {
	  window.___replace(to);
	};
	
	var navigateTo = exports.navigateTo = push;

/***/ }),

/***/ 393:
/***/ (function(module, exports) {

	'use strict';
	
	var isArray = Array.isArray;
	var keyList = Object.keys;
	var hasProp = Object.prototype.hasOwnProperty;
	var hasElementType = typeof Element !== 'undefined';
	
	function equal(a, b) {
	  // fast-deep-equal index.js 2.0.1
	  if (a === b) return true;
	
	  if (a && b && typeof a == 'object' && typeof b == 'object') {
	    var arrA = isArray(a)
	      , arrB = isArray(b)
	      , i
	      , length
	      , key;
	
	    if (arrA && arrB) {
	      length = a.length;
	      if (length != b.length) return false;
	      for (i = length; i-- !== 0;)
	        if (!equal(a[i], b[i])) return false;
	      return true;
	    }
	
	    if (arrA != arrB) return false;
	
	    var dateA = a instanceof Date
	      , dateB = b instanceof Date;
	    if (dateA != dateB) return false;
	    if (dateA && dateB) return a.getTime() == b.getTime();
	
	    var regexpA = a instanceof RegExp
	      , regexpB = b instanceof RegExp;
	    if (regexpA != regexpB) return false;
	    if (regexpA && regexpB) return a.toString() == b.toString();
	
	    var keys = keyList(a);
	    length = keys.length;
	
	    if (length !== keyList(b).length)
	      return false;
	
	    for (i = length; i-- !== 0;)
	      if (!hasProp.call(b, keys[i])) return false;
	    // end fast-deep-equal
	
	    // start react-fast-compare
	    // custom handling for DOM elements
	    if (hasElementType && a instanceof Element && b instanceof Element)
	      return a === b;
	
	    // custom handling for React
	    for (i = length; i-- !== 0;) {
	      key = keys[i];
	      if (key === '_owner' && a.$$typeof) {
	        // React-specific: avoid traversing React elements' _owner.
	        //  _owner contains circular references
	        // and is not needed when comparing the actual elements (and not their owners)
	        // .$$typeof and ._store on just reasonable markers of a react element
	        continue;
	      } else {
	        // all other properties should be traversed as usual
	        if (!equal(a[key], b[key])) return false;
	      }
	    }
	    // end react-fast-compare
	
	    // fast-deep-equal index.js 2.0.1
	    return true;
	  }
	
	  return a !== a && b !== b;
	}
	// end fast-deep-equal
	
	module.exports = function exportedEqual(a, b) {
	  try {
	    return equal(a, b);
	  } catch (error) {
	    if ((error.message && error.message.match(/stack|recursion/i)) || (error.number === -2146828260)) {
	      // warn on circular references, don't crash
	      // browsers give this different errors name and messages:
	      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
	      // firefox: "InternalError", too much recursion"
	      // edge: "Error", "Out of stack space"
	      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
	      return false;
	    }
	    // some other error. we should definitely know about these
	    throw error;
	  }
	};


/***/ }),

/***/ 394:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(413);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _reactFastCompare = __webpack_require__(393);
	
	var _reactFastCompare2 = _interopRequireDefault(_reactFastCompare);
	
	var _HelmetUtils = __webpack_require__(395);
	
	var _HelmetConstants = __webpack_require__(179);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _reactFastCompare2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	             * @param {Object} bodyAttributes: {"className": "root"}
	             * @param {String} defaultTitle: "Default Title"
	             * @param {Boolean} defer: true
	             * @param {Boolean} encodeSpecialCharacters: true
	             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	             * @param {String} title: "Title"
	             * @param {Object} titleAttributes: {"itemprop": "name"}
	             * @param {String} titleTemplate: "MySite.com - %s"
	             */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 179:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 395:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(5);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(179);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(2);
	var React__default = _interopDefault(React);
	var shallowEqual = _interopDefault(__webpack_require__(431));
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(SideEffect, _Component);
	
	      function SideEffect() {
	        return _Component.apply(this, arguments) || this;
	      }
	
	      // Try to use displayName of wrapped component
	      // Expose canUseDOM so tests can monkeypatch it
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      var _proto = SideEffect.prototype;
	
	      _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      _proto.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      _proto.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      _proto.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      _proto.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
	
	    _defineProperty(SideEffect, "canUseDOM", canUseDOM);
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),

/***/ 288:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 431:
/***/ (function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Bio = function (_Component) {
	  _inherits(Bio, _Component);
	
	  function Bio() {
	    _classCallCheck(this, Bio);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Bio.prototype.render = function render() {
	    return _react2.default.createElement("div", { className: "bio" });
	  };
	
	  return Bio;
	}(_react.Component);
	
	exports.default = Bio;
	module.exports = exports["default"];

/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LessonsPage = function LessonsPage(_ref) {
	  var active = _ref.active;
	  return _react2.default.createElement(
	    'div',
	    { className: 'Lessons ' + (active ? 'is-active' : '') },
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Voice Lessons'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Over the years I\u2019ve given hundreds of people tips, tricks, and walked them through the process of growing their voice.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Everyone has individual desires, things they want to work on, problems that they have. I\u2019m here to help build your confidence and knowledge base to help you become the singer you\u2019d like to be!'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Beginners are more than welcome, everyone has to start somewhere.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement(
	        'a',
	        { href: 'mailto:info@bradleywalden.com' },
	        'Email'
	      ),
	      ' now for pricing & to set up your first lesson!'
	    )
	  );
	};
	
	exports.default = LessonsPage;
	module.exports = exports['default'];

/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LyricsPage = function LyricsPage(_ref) {
	  var active = _ref.active;
	  return _react2.default.createElement(
	    'div',
	    { className: 'Lyrics ' + (active ? 'is-active' : '') },
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Handwritten Lyrics'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Thank you so much for looking into a handwritten lyric sheet! Over the course of my career, I\u2019ve written quite a few songs that have thankfully resonated with so many of you. I\u2019d like to give this opportunity to have them written out for you, by me.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'I\u2019m looking forward to creating this keepsake for you.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      '(All orders will be shipped within 2-4 weeks)'
	    ),
	    _react2.default.createElement(
	      'form',
	      {
	        action: 'https://www.paypal.com/cgi-bin/webscr',
	        method: 'post',
	        target: '_top'
	      },
	      _react2.default.createElement('input', { type: 'hidden', name: 'cmd', value: '_s-xclick' }),
	      _react2.default.createElement('input', { type: 'hidden', name: 'hosted_button_id', value: '4H8SQREN8JHRU' }),
	      _react2.default.createElement('input', { type: 'hidden', name: 'on0', value: 'Song Choice:' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'buynow-inputs' },
	        _react2.default.createElement('input', {
	          className: 'buynow-song',
	          type: 'text',
	          name: 'os0',
	          maxLength: '200',
	          placeholder: 'Song Choice'
	        }),
	        _react2.default.createElement(
	          'p',
	          { className: 'buynow-price' },
	          '$85'
	        ),
	        _react2.default.createElement('input', {
	          className: 'buynow',
	          type: 'image',
	          src: 'http://squidthewhale.com/buynow.png',
	          name: 'submit',
	          alt: 'PayPal - The safer, easier way to pay online!'
	        })
	      ),
	      _react2.default.createElement('img', {
	        alt: '',
	        src: 'https://www.paypalobjects.com/en_US/i/scr/pixel.gif',
	        width: '1',
	        height: '1'
	      })
	    )
	  );
	};
	
	exports.default = LyricsPage;
	module.exports = exports['default'];

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(154);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _instagram = __webpack_require__(432);
	
	var _instagram2 = _interopRequireDefault(_instagram);
	
	var _twitter = __webpack_require__(433);
	
	var _twitter2 = _interopRequireDefault(_twitter);
	
	var _iconMail = __webpack_require__(434);
	
	var _iconMail2 = _interopRequireDefault(_iconMail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Nav = function Nav() {
	  return _react2.default.createElement(
	    'nav',
	    { className: 'nav' },
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { className: 'logo', to: '/' },
	      'Badley'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'socials' },
	      _react2.default.createElement(
	        'a',
	        { href: 'https://twitter.com/rnbadley', target: '_blank' },
	        _react2.default.createElement(_twitter2.default, { className: 'twitter' })
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: 'https://instagram.com/bradleyscott', target: '_blank' },
	        _react2.default.createElement(_instagram2.default, { className: 'instagram' })
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: 'mailto:info@bradleywalden.com' },
	        _react2.default.createElement(_iconMail2.default, { className: 'mail' })
	      )
	    )
	  );
	};
	// images
	exports.default = Nav;
	module.exports = exports['default'];

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SongShopPage = function SongShopPage(_ref) {
	  var active = _ref.active;
	  return _react2.default.createElement(
	    'div',
	    { className: 'Songshop ' + (active ? 'is-active' : '') },
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Song Shop'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Ever wanted your own personal song? Maybe a love song for your pup? (Please order a love song for your pup).'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Whatever you\u2019d like your song to be about, whoever you\u2019d like your song to be for, it\u2019s completely up to you! You can help with the lyrics, share your story, tell someone how you feel. The sky is the limit!'
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'Songwriting-disclaimer' },
	      '(You\'ll receive an email within 24 hours to discuss your song)'
	    ),
	    _react2.default.createElement('p', null),
	    _react2.default.createElement(
	      'p',
	      { className: 'Songwriting-title' },
	      _react2.default.createElement(
	        'span',
	        null,
	        'Full Song: $200'
	      ),
	      _react2.default.createElement('br', null),
	      'A full length piano/acoustic style recording.'
	    ),
	    _react2.default.createElement(
	      'form',
	      {
	        action: 'https://www.paypal.com/cgi-bin/webscr',
	        method: 'post',
	        target: '_top'
	      },
	      _react2.default.createElement('input', { type: 'hidden', name: 'cmd', value: '_s-xclick' }),
	      _react2.default.createElement('input', { type: 'hidden', name: 'hosted_button_id', value: 'J695MX56XYQXL' }),
	      _react2.default.createElement('input', {
	        className: 'buynow',
	        type: 'image',
	        src: 'http://squidthewhale.com/buynow.png',
	        name: 'submit',
	        alt: 'PayPal - The safer, easier way to pay online!'
	      }),
	      _react2.default.createElement('img', {
	        alt: '',
	        src: 'https://www.paypalobjects.com/en_US/i/scr/pixel.gif',
	        width: '1',
	        height: '1'
	      })
	    ),
	    _react2.default.createElement('p', null),
	    _react2.default.createElement('p', null),
	    _react2.default.createElement(
	      'p',
	      { className: 'Songwriting-title' },
	      _react2.default.createElement(
	        'span',
	        null,
	        'Diamond Song: $375'
	      ),
	      _react2.default.createElement('br', null),
	      'A full length & full production song. This is the complete package.'
	    ),
	    _react2.default.createElement(
	      'form',
	      {
	        action: 'https://www.paypal.com/cgi-bin/webscr',
	        method: 'post',
	        target: '_top'
	      },
	      _react2.default.createElement('input', { type: 'hidden', name: 'cmd', value: '_s-xclick' }),
	      _react2.default.createElement('input', { type: 'hidden', name: 'hosted_button_id', value: '9L7MD4VXU8ZK4' }),
	      _react2.default.createElement('input', {
	        className: 'buynow',
	        type: 'image',
	        src: 'http://squidthewhale.com/buynow.png',
	        name: 'submit',
	        alt: 'PayPal - The safer, easier way to pay online!'
	      }),
	      _react2.default.createElement('img', {
	        alt: '',
	        src: 'https://www.paypalobjects.com/en_US/i/scr/pixel.gif',
	        width: '1',
	        height: '1'
	      })
	    )
	  );
	};
	
	exports.default = SongShopPage;
	module.exports = exports['default'];

/***/ }),

/***/ 437:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALQAAAC0CAMAAAAKE/YAAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAC31BMVEUAAAATDgcrIBAvIhItIREqHxAlGw4hGAwbEwoUDgcNCQUIBgMDAgEjGg1bQyNaQiMiGA0cFAp6WS/Jk03lqFjnqVnmqVnkp1jgpFbcolXVnVLOl0/Dj0u3hkeqfEGccjyQajiGYjN9XDB1Vi1vUitqTiloTChmSidlSidkSSZyVCx/XTGUbTlPOh4KBwTWnVP3tV/TmlFNOR4BAQBINRzHkk34tmASDQeRazjysV3aoFQ3KBUEAwFnSyfjp1gxJBP2tF+vgEMCAgHsrVvzsl6rfUIGBAIPCwaZcDvxsV1VPiHpq1q7iUidczxjSCb1s15dRCSOaDcyJRPYn1OJZDVJNhwgFwwuIhLUnFIfFgx7Wi84KRUJBwOnekB5WS8aEwpHNBuVbTntrlt+XDBFMhrwsFxLNx26iUgLCASKZTXboVVBLxkHBQOxgUQVDwgoHQ/LlU4nHQ+uf0NhRyUkGw6HYzSsfkJKNhxXQCFCMBmDYDKtf0NtUCrrrFtDMRkRDAYdFQsMCQSwgUSIYzS8ikmCXzK/jEqNZzY/Lhg+LRg0JhTipld0VS3Bjkp8WzBROx92Vy30s164h0eAXjFGNBtzVCyXbzo7KxYZEgnCjktgRiWjdz9pTSiMZjYWEAgFBAKpfEE2JxVrTynGkUxfRSTKlE6TbDnIk02hdj7qrFq2hkbUm1LZn1Q1JxToqllOOR7vr1wOCgWPaTeSazgzJRPurlyleUBuUSqkeD86KhbRmVApHhDhpVdYQCKYcDtcQyO0hEamekAYEQkeFgvMlU/QmFCacTu1hUYmHA+WbjqfdT1QOx9qTSlTPSBwUiubcjxEMRqxgkTAjUpWPyFALxgsIBGoe0E9LBeedD2gdT6yg0XEkEyzhEXeo1bfpFZ3Vy6EYTPdolUQDAZsTypUPiA8LBcwIxI5KhaNaDa9i0nNlk/SmlFZQSLFkEzXnlOidz4jGQ0XEQm+i0m5iEf///8zHwzDAAAAAWJLR0T0MtUrTQAAAAd0SU1FB+UMBAQvDatrtssAAAhBSURBVHja7Zz9X013HMCPPES3lPSIItwh3C43J6X1JF0tdUtUcml6ELnLPI5I8hBSptZSWI3NlqjFtGE0hhkxRNvY2MZsswdm+wd27j1Pn3Pu0V5u3df37PX6vn+o1/18vq9z3p2+fZ9PBIHBYDAYDAaDwWAwGAwGg8FgMBgMBoPBdJJuNt179Oxl27uPncK+w4IOfR2dUMvS9HPu7+Lq5u7hOWDgIC/vwUN8hg4brnxhxMhRFErf0WPGsgVVSj+1etx41L4UGv8JarJDnJmSARMDjR+DJqFWJoJfdOlYmQwJZZwHh9GBcDvEzhHKyWaWkZGCj1OiTCW1U9lfSPRLiKUdY6BfdNC02NFx/r6BIKaLNxVUJYRxoXAFUufpicBu4IyZSSoNFU12A9Ips4wFg1PB43edjdJZP4c3cZ+bxoZfjgbS84w/BhGXDn8jGSilM3mVFH8NF3YGflnzTQU9BNU8ewFC6YWcRs4iPmp4Bfj1z6Uii18V/ql6LEHnHLyUe57LQHi5J/BbQQUCVoral8DX0Enbe7MWc/QgvErH66Wvpn62PKrhUA9aA9qUteikiTzGIX8djM4Dz3RQAfVD5BubufWFG/jwRoTSq5meZVMhCObCCryZagBTqO9FtgQRz7fUQxBKq9bQDltgcCto3fK3EQHh1PcBxVSi53YuvsXCG3YJW0NMDiUwlgoedKmW2EE9X9fXjYmC/lw8D6W0ZmeZWFpVDqTfICqo8VTgm6Y2PJhvREosvF/XUFippmsuR3IIqB27qqqpb5UqOjWRS+xGKk302UNZV4LAXlg7ct+ivk7rzaQy2Hh0BVppoiZWR3rxw7bat+EYYyzV2iXuY3P72XiIDWJpQrsiKyiJ++SQwzvHxL9DdS/xXO5dNnGgG2ppIiruvQDuQ1++MSbf30P1hAtrudwyNlEXgdqZakN4r4hYUDtSDpJkfQ1fTskm9qM2FrL+EJCmHvrhBpBkh6yN+yy+vlX4AM60SLJJ0LaxTV7REdSaQo4KnMkPDSBXG85EU1FbCulzQOBc1A8mcwfSUfdjqDWFrGuGzh5bBckGZub+URRqTSF50DnyY2GSaTyaEU5bpNCWQunjhYJkFDNeWqpCrSnkxEHgfPITYTL5lCl8EPW4Q8xc4Jx+WjrZUmvRpa1GYTaQPiqSS6NnYeMWo7YUUewGKkeSKKk0DUqaP0UtKcYXPOgEUS7J1EiHzZBZc0foz/DO0fOFOXt6MepsAWpJMd3deemBnwlz4xuNUa9zqB3NWAsHHcLUkvPGYCnCJbxnoADrjoHC3aAa06JfKfJJljk9+LUY8kIazGg/N07ZL36B2lACJagd82Ci4JKOJMsu97b0wlbEEM47R7aCxLnjVAsdswP1lpYkNqd46XFgHD27yFhdWu0tv7IVuQJqRwu3laGIy6G6lLPyazZMGJbyzmVX2eiS2Czqs+5L1HbPwAZsBaUwfYjdSGZuvn1d5y5uLWDtuGaqHVHXb3BT87a0zl7fGsC2o+wmFVDcqoMzAh8ZrCmZ0Q7aDj9qVLrtK6hMki5fozaUAPYs31BPtYUUcRbtfrgUCrBzpXOkAscGiaTzM1E7mpEMxh2JTsZIr3KR9e1g1JJi4Ki0ju78lpcKpbeHopYUob/Dy4XFM8FJiULroagtRXQHm0NBDmx0d5ZA+tuAztyi6xkO3I5zdVdfJ5BOX9SZW3Q5+u9A7QAr0tPvCqyRHk0xIxTMaD17gYSPQNpLVot4cL1jDlxY6pkDpe/Jab61oJ4XU8fBjGYIlC5rtfQOVgCuht0VDvdv5UPrHahNAd8DL2/hsqO2DUrvkc9Qz24a8BohSv4ApdsKLbqBNTgBDkHeEy2kE/PhFt2hKtSuHBlAa414UdThR5A9JZvm43410NorztrBSh0zHbUsyyJwZOlUuziruQ078l2oZVk2AqsNBrP0ZpBuuoValiEX7tE+MM/DgzZZchkyzQTjz5Bk8/xP4PxH+gnUtgywo74jMXmtAG2eu0wWqNMuAOnhEgUegt3yFJks2bTCB/mzRIF9YPThpX/u61sDDVzfuCg1Xj4GFm2QHtbkOZcCpH2lShTz0rrTz3t567CqjHd2kzx78gvf9wgmNeiwvwwedLnkQf9M/qWGKfLYrXU4DKSHSRY5zb0jpR6FWpdmGeg5XBski5RwBfycUOuaiPIGDzpbeoTPNy+/otal6QnfXpkrWYQfmrrL5AThAzhWln61qZ1bMGuRx6qpChyVIB9Jb26OYv8OPYpR69I0uAFp6eUBw0o276N5zqtbCfjGwkHpSckk9g3L32xR29IUwMlhm1aqSAQ7cG1yRG3LkAmPaI6WLNLA7nldMjznxa0FPMCbL7njpmBntdWzUMsy9PsdSFfflyri2ERncx6ilmX5AwzwBC+6cPQYRycbZTIkJYha8KYqmS61NlDF7A+k75fNumMP2IX/KbEH1I3ZcWnaKZ/DpSXAmfQxz1fV0X1h8055jKKN3IdrdM3mxznaz9DOrkr5PGeiAjbSE8QvCCkcmdMpj6/Kpj5Ts3D4Sqr45VP7SU/otk5dLpNREs1fj4Ez848DGOwWTWV26Bp9aiy8vHW4IvjvGIkbtz01/rkF2zlVZPzNvHcbWZ4pr2NtR+CRdCOTT96JvTR4ZXUOO/fWTYi73/n7dCkzm8kOaXo06ilqRzMSOjIu82vx13b+Hl3O9NRr9ec9G6PDzIRdJoy5OUtGzZwQRTfb0Our9jovrHwy5UZ99qZN/9w4nuDbmlwgk2nVf6CxrzXoVSp97f9DF4PBYDAYDAaDwWAwGAwGg8FgMBgMBoPBPJt/AZfKUipTTueJAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIxLTEyLTA0VDA0OjQ3OjEzKzAwOjAwsahrbAAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyMS0xMi0wNFQwNDo0NzoxMyswMDowMMD109AAAABXelRYdFJhdyBwcm9maWxlIHR5cGUgaXB0YwAAeJzj8gwIcVYoKMpPy8xJ5VIAAyMLLmMLEyMTS5MUAxMgRIA0w2QDI7NUIMvY1MjEzMQcxAfLgEigSi4A6hcRdPJCNZUAAAAASUVORK5CYII="

/***/ }),

/***/ 438:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABGlBMVEUAAAD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD///9L87BIAAAAXHRSTlMAABxHPzUwCi0SF7i3edtZ3Wsqyiw786+FoANDEHyoIbKPDL/qPg66SjPvi1OHCHX0SVJ/vctk8bQLiRPBOXj2RF0NwtD7WDqNaeAmg/hGrgEW0SuChJemRQcFAoJP3J8AAAABYktHRF2d3zABAAAAB3RJTUUH5QwEBC8Nq2u2ywAAAKpJREFUGNNFztUOwkAUBNAd3J3iFHco7lrc3fn/7yCB7Pa+zUkmdwghBJDJFUqVWqMF+R10eoPRZDBbrPgLbHaHk3O5TR4KXp8/8AnyoTBoB5FoLJ5IpigQpDNZ5PIFliEUS+WKn2YCdbVWbzRbEqQz7U6X60mN/mAI4TNiII4nHZinMwZzbgEsV2u2YrPdQdwHDhSOJ8t5fbmKrMHf7lfh8ZSe4vAqvOnqL8HkFJX322m3AAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIxLTEyLTA0VDA0OjQ3OjEzKzAwOjAwsahrbAAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyMS0xMi0wNFQwNDo0NzoxMyswMDowMMD109AAAABXelRYdFJhdyBwcm9maWxlIHR5cGUgaXB0YwAAeJzj8gwIcVYoKMpPy8xJ5VIAAyMLLmMLEyMTS5MUAxMgRIA0w2QDI7NUIMvY1MjEzMQcxAfLgEigSi4A6hcRdPJCNZUAAAAASUVORK5CYII="

/***/ }),

/***/ 439:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAB11BMVEUAAAD4tmD2t2L4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD4tmD////cWCy7AAAAm3RSTlMAAAACNmRhV0tBPj8NIh0B6Pjcxuv2zBUmxJkEMuXaWxwo3YsYu+MnVf31UkXzSpXL3vpNIdbXFoPHecUlj7kawbpDcUIMNe3mam7fc50JiKYFCLa/LVOXB80UG8O0sY2ioypHac6W7lQRvQ4s5/fybNIXY/x4kzDpdNQZpAu8nDf5UH0PExCaWET0rZLYiR/ZsOxZ/rfKqoBaBt63LlsAAAABYktHRJxxvMInAAAAB3RJTUUH5QwEBC8OMmLncQAAAbtJREFUOMulku0/02EUxneFNayx1g+T2kQx2ZIN2ZJaFhJmhdWahjwsMWJ6fqBUHvJc0vXPdvPyt/Oiz6f75Tnfz3Xd1znHYPjnh6zsHONJU25eXr4Zp3IsgK5fYCyk9bTtjGYtKi6xs/SsHig7x/MOZ/kFsqLyInmpSg9Uu2ouA7Ua3Z4rdVdZ79UDvobGJuAa2ewPXG+hq1oPwHSjFeab5K1AELeptekA9cuSEO6009XRCdxll08PHKvcI9ndA/Qy3CcBkftkkQ8IPdA8kID+QmoDADzuwajo0Ek+fATEHscrRYHoEPlE9RPDMalvwEgHtVEEbfZiqa0cnpJj/eMTdE/KAkcOLcmwSvpsSgSeT3PGBEsdmcoXM8yScy+A+QUyLXggEicXTwC+LjJRIAAvX9HqVVOKqGuIZw4aeE2+eQu1tHfkkAC8/0AOKmXgowqT+Qd8muDSsqojK0zrcgYAfCYbY6qML80MrGQKfA2Q344dclPad0FgdY31A0cO5nVuRIUMG+QPpwoZ2lxKrAhD2Nomd6b6km07u71JIQL2avaZsv38tX0QFI8RrbWOWf/v9OHIH3HT//P+AupLc+sIt87EAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIxLTEyLTA0VDA0OjQ3OjE0KzAwOjAwdA9V4gAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyMS0xMi0wNFQwNDo0NzoxNCswMDowMAVS7V4AAABXelRYdFJhdyBwcm9maWxlIHR5cGUgaXB0YwAAeJzj8gwIcVYoKMpPy8xJ5VIAAyMLLmMLEyMTS5MUAxMgRIA0w2QDI7NUIMvY1MjEzMQcxAfLgEigSi4A6hcRdPJCNZUAAAAASUVORK5CYII="

/***/ }),

/***/ 434:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(2);
	
	function Mail (props) {
	    return React.createElement("svg",props,React.createElement("path",{"d":"M2 0H18C18.5304 0 19.0391 0.210714 19.4142 0.585786C19.7893 0.960859 20 1.46957 20 2V14C20 14.5304 19.7893 15.0391 19.4142 15.4142C19.0391 15.7893 18.5304 16 18 16H2C1.46957 16 0.960859 15.7893 0.585786 15.4142C0.210714 15.0391 0 14.5304 0 14V2C0 0.9 0.9 0 2 0ZM18 3.38V2H2V3.38L10 7.38L18 3.38ZM18 5.62L10.45 9.39C10.3104 9.46033 10.1563 9.49697 10 9.49697C9.8437 9.49697 9.68958 9.46033 9.55 9.39L2 5.62V14H18V5.62Z","fill":"#121212","fillOpacity":"0.64"}));
	}
	
	Mail.defaultProps = {"width":"20","height":"16","viewBox":"0 0 20 16","fill":"none"};
	
	module.exports = Mail;
	
	Mail.default = Mail;


/***/ }),

/***/ 432:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(2);
	
	function Instagram (props) {
	    return React.createElement("svg",props,[React.createElement("path",{"d":"M9.59661 1.71185C12.1031 1.71185 12.3973 1.72316 13.388 1.76841C14.3041 1.80988 14.7995 1.96448 15.1309 2.09645C15.5704 2.26989 15.8832 2.47351 16.211 2.80532C16.5387 3.13713 16.7436 3.45386 16.9111 3.89879C17.0378 4.23437 17.1942 4.73586 17.2352 5.66343C17.2799 6.6664 17.291 6.96428 17.291 9.50189C17.291 12.0395 17.2799 12.3374 17.2352 13.3403C17.1942 14.2679 17.0415 14.7694 16.9111 15.105C16.7398 15.5499 16.5387 15.8666 16.211 16.1985C15.8832 16.5303 15.5704 16.7376 15.1309 16.9073C14.7995 17.0355 14.3041 17.1939 13.388 17.2354C12.3973 17.2806 12.1031 17.2919 9.59661 17.2919C7.09015 17.2919 6.79593 17.2806 5.80527 17.2354C4.88909 17.1939 4.39376 17.0393 4.06229 16.9073C3.62283 16.7339 3.30999 16.5303 2.98225 16.1985C2.65451 15.8666 2.44967 15.5499 2.28208 15.105C2.15545 14.7694 1.99903 14.2679 1.95806 13.3403C1.91337 12.3374 1.9022 12.0395 1.9022 9.50189C1.9022 6.96428 1.91337 6.6664 1.95806 5.66343C1.99903 4.73586 2.15173 4.23437 2.28208 3.89879C2.45339 3.45386 2.65451 3.13713 2.98225 2.80532C3.30999 2.47351 3.62283 2.26612 4.06229 2.09645C4.39376 1.96825 4.88909 1.80988 5.80527 1.76841C6.79593 1.71939 7.09388 1.71185 9.59661 1.71185ZM9.59661 0C7.04919 0 6.7289 0.0113118 5.72706 0.0565588C4.72895 0.101806 4.0474 0.263941 3.45151 0.497718C2.83327 0.739036 2.31187 1.06708 1.79047 1.59496C1.26907 2.12284 0.948776 2.6545 0.706696 3.27664C0.475789 3.87994 0.315644 4.56995 0.270952 5.58424C0.226261 6.59476 0.215088 6.91903 0.215088 9.49811C0.215088 12.0772 0.226261 12.4015 0.270952 13.4158C0.315644 14.4263 0.475789 15.1163 0.706696 15.7234C0.945052 16.3493 1.26907 16.8772 1.79047 17.405C2.31187 17.9329 2.837 18.2572 3.45151 18.5023C4.0474 18.7361 4.72895 18.8982 5.73078 18.9434C6.73262 18.9887 7.04919 19 9.60034 19C12.1515 19 12.4681 18.9887 13.4699 18.9434C14.468 18.8982 15.1495 18.7361 15.7492 18.5023C16.3674 18.261 16.8888 17.9329 17.4102 17.405C17.9316 16.8772 18.2519 16.3455 18.494 15.7234C18.7249 15.1201 18.885 14.43 18.9297 13.4158C18.9744 12.4015 18.9856 12.081 18.9856 9.49811C18.9856 6.91526 18.9744 6.59476 18.9297 5.58047C18.885 4.56995 18.7249 3.87994 18.494 3.27287C18.2556 2.64695 17.9316 2.11907 17.4102 1.59119C16.8888 1.06331 16.3637 0.739036 15.7492 0.493947C15.1533 0.260171 14.4717 0.0980353 13.4699 0.0527883C12.4643 0.0113118 12.144 0 9.59661 0Z","fillOpacity":"0.64","key":0}),React.createElement("path",{"d":"M9.59635 4.62274C6.9372 4.62274 4.7771 6.80591 4.7771 9.50188C4.7771 12.1979 6.93347 14.381 9.59635 14.381C12.2592 14.381 14.4156 12.1979 14.4156 9.50188C14.4156 6.80591 12.2592 4.62274 9.59635 4.62274ZM9.59635 12.6654C7.86827 12.6654 6.46793 11.2477 6.46793 9.49811C6.46793 7.74856 7.86827 6.33082 9.59635 6.33082C11.3244 6.33082 12.7248 7.74856 12.7248 9.49811C12.7248 11.2477 11.3244 12.6654 9.59635 12.6654Z","fillOpacity":"0.64","key":1}),React.createElement("path",{"d":"M14.6059 5.5654C15.2272 5.5654 15.7309 5.05558 15.7309 4.42668C15.7309 3.79779 15.2272 3.28796 14.6059 3.28796C13.9846 3.28796 13.481 3.79779 13.481 4.42668C13.481 5.05558 13.9846 5.5654 14.6059 5.5654Z","fill":"white","fillOpacity":"0.64","key":2})]);
	}
	
	Instagram.defaultProps = {"width":"19","height":"19","viewBox":"0 0 19 19","fill":"none"};
	
	module.exports = Instagram;
	
	Instagram.default = Instagram;


/***/ }),

/***/ 433:
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(2);
	
	function Twitter (props) {
	    return React.createElement("svg",props,React.createElement("path",{"d":"M7.36606 19C16.0813 19 20.8502 11.6844 20.8502 5.35098C20.8502 5.14517 20.8502 4.93936 20.841 4.73355C21.7652 4.05063 22.5692 3.20868 23.2069 2.25446C22.3382 2.63802 21.4232 2.89996 20.4805 3.01222C21.4694 2.4135 22.2088 1.46864 22.56 0.355387C21.6265 0.91669 20.6099 1.3096 19.5471 1.51541C17.7541 -0.421082 14.7505 -0.514633 12.8373 1.3096C11.6082 2.47898 11.0814 4.22838 11.4695 5.89358C7.67104 5.69712 4.11286 3.87289 1.70992 0.879269C0.453004 3.06835 1.09071 5.87487 3.17941 7.27812C2.42156 7.25941 1.69144 7.0536 1.02601 6.6794C1.02601 6.69811 1.02601 6.71682 1.02601 6.73553C1.02601 9.01816 2.61564 10.9827 4.83374 11.4411C4.13134 11.6376 3.40122 11.6656 2.68958 11.5253C3.3088 13.4805 5.09251 14.8183 7.11652 14.8557C5.43447 16.1935 3.36425 16.9138 1.22934 16.9138C0.850413 16.9138 0.471489 16.8858 0.101807 16.8483C2.27369 18.261 4.78752 19 7.36606 19Z","fillOpacity":"0.64"}));
	}
	
	Twitter.defaultProps = {"width":"24","height":"19","viewBox":"0 0 24 19","fill":"none"};
	
	module.exports = Twitter;
	
	Twitter.default = Twitter;


/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(394);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyImage = __webpack_require__(301);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _gatsbyLink = __webpack_require__(154);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _nav = __webpack_require__(200);
	
	var _nav2 = _interopRequireDefault(_nav);
	
	var _bio = __webpack_require__(197);
	
	var _bio2 = _interopRequireDefault(_bio);
	
	var _lessons = __webpack_require__(198);
	
	var _lessons2 = _interopRequireDefault(_lessons);
	
	var _songshop = __webpack_require__(201);
	
	var _songshop2 = _interopRequireDefault(_songshop);
	
	var _lyrics = __webpack_require__(199);
	
	var _lyrics2 = _interopRequireDefault(_lyrics);
	
	__webpack_require__(288);
	
	__webpack_require__(326);
	
	var _appleTouchIcon = __webpack_require__(437);
	
	var _appleTouchIcon2 = _interopRequireDefault(_appleTouchIcon);
	
	var _favicon32x = __webpack_require__(439);
	
	var _favicon32x2 = _interopRequireDefault(_favicon32x);
	
	var _favicon16x = __webpack_require__(438);
	
	var _favicon16x2 = _interopRequireDefault(_favicon16x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// components
	
	// styles
	
	// images
	
	
	var Layout = function (_Component) {
	  _inherits(Layout, _Component);
	
	  function Layout(props) {
	    _classCallCheck(this, Layout);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      showAllContent: false
	    };
	    return _this;
	  }
	
	  Layout.prototype.componentDidMount = function componentDidMount() {
	    window.addEventListener('resize', this.resize.bind(this));
	    this.resize();
	  };
	
	  Layout.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener('resize', this.resize.bind(this));
	  };
	
	  Layout.prototype.resize = function resize() {
	    this.setState({
	      showAllContent: window.innerWidth < 640
	    });
	  };
	
	  Layout.prototype.render = function render() {
	    var _props = this.props,
	        data = _props.data,
	        pathname = _props.location.pathname;
	    var bg = data.bg,
	        site = data.site;
	    var showAllContent = this.state.showAllContent;
	
	    var activePage = pathname.split('/')[1];
	    var goodUrl = activePage === 'lessons' || activePage === 'lyricsheet' || activePage === 'songshop';
	
	    return _react2.default.createElement(
	      'div',
	      { className: !!activePage && goodUrl ? 'is-active' : '' },
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        {
	          title: site.siteMetadata.title,
	          meta: [{
	            name: 'description',
	            content: 'Bradley Walden: singer, songwriter, performer.'
	          }, {
	            name: 'keywords',
	            content: 'bradley walden, voice lessons, songwriting, emarosa, music, band'
	          }, { name: 'msapplication-TileColor', content: '#00000' }, { name: 'theme-color', content: '#00000' }]
	        },
	        _react2.default.createElement('link', { rel: 'apple-touch-icon', sizes: '180x180', href: _appleTouchIcon2.default }),
	        _react2.default.createElement('link', { rel: 'icon', type: 'image/png', sizes: '32x32', href: _favicon32x2.default }),
	        _react2.default.createElement('link', { rel: 'icon', type: 'image/png', sizes: '16x16', href: _favicon16x2.default })
	      ),
	      _react2.default.createElement(
	        'header',
	        { className: 'header' },
	        _react2.default.createElement(_gatsbyImage2.default, {
	          style: {
	            position: 'absolute',
	            top: 0,
	            left: 0,
	            height: '100%',
	            width: '100%'
	          },
	          sizes: bg.sizes
	        }),
	        _react2.default.createElement(_nav2.default, null),
	        _react2.default.createElement(_bio2.default, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'buttons' },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            {
	              className: 'button ' + (activePage === 'songshop' ? 'is-active' : ''),
	              to: '/songshop'
	            },
	            'Song Shop'
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            {
	              className: 'button ' + (activePage === 'lyricsheet' ? 'is-active' : ''),
	              to: '/lyricsheet'
	            },
	            'Handwritten Lyrics'
	          ),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            {
	              className: 'button ' + (activePage === 'lessons' ? 'is-active' : ''),
	              to: '/lessons'
	            },
	            'Voice Lessons'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'main',
	        { className: 'content' },
	        _react2.default.createElement(_songshop2.default, { active: showAllContent || activePage === 'songshop' }),
	        _react2.default.createElement(_lyrics2.default, { active: showAllContent || activePage === 'lyricsheet' }),
	        _react2.default.createElement(_lessons2.default, { active: showAllContent || activePage === 'lessons' }),
	        (showAllContent || activePage) && _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: 'close', to: '/' },
	          '+'
	        )
	      )
	    );
	  };
	
	  return Layout;
	}(_react.Component);
	
	exports.default = Layout;
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 326:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-3ed5b5a81a45ed51829b.js